/**
 * Created by dengxingyang on 17/7/31.
 */
import Vue from 'vue'
export default new Vue()



// WEBPACK FOOTER //
// ./src/assets/js/bus.js